var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 116,
    viewBox: "0 0 181 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.067 115.74H135.363C124.98 115.74 116.56 107.321 116.56 96.9376C116.56 88.5119 122.101 81.385 129.733 78.9923L116.439 56.3383L96.6446 89.9962C82.1284 114.768 50.134 123.117 25.3432 108.581C0.795606 94.193 -7.32936 62.2753 7.2316 37.427L23.4176 9.73172C28.6508 0.762271 40.1665 -2.2574 49.136 2.98224C58.1054 8.22189 61.1251 19.7376 55.8854 28.7006L39.6931 56.4151C37.6522 59.8954 37.0445 63.8619 37.9721 67.5981C38.8614 71.2128 41.1325 74.2388 44.3633 76.1325C51.2664 80.1758 60.1718 77.8535 64.2215 70.9505L100.253 9.68694C103.631 3.94189 109.798 0.416801 116.458 0.416801H116.464C123.131 0.416801 129.298 3.95468 132.676 9.70613L178.285 87.4243C181.694 93.2397 181.733 100.437 178.387 106.284C175.035 112.132 168.81 115.74 162.067 115.74Z",
    fill: "#D7DF23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/LogoIcon.31d809ac255014e6f5fe5f995afcb0e4.svg";
export { ForwardRef as ReactComponent };